// Models
export { default as MortgageCalculatorDocument } from './models/MortgageCalculatorDocument';

// Definitions
export { CALCULATOR_TYPES } from './models/CalculatorType';
export { default as HOME_TYPES } from './definitions/HomeType';
export { default as INSURABILITY } from './definitions/Insurability';
// Re-exporting definitions from other document
export { INTENDED_USE, PAYMENT_FREQUENCIES, RATE_TYPES } from '../../mtg-journey-document/stable';

// Functions
export { default as migrate } from './functions/migrate';
export { default as validate } from './functions/validate';
export { default as extractMetadata } from './functions/extractMetadata';

// Configuration
export { default as SchemaOptions } from './definitions/SchemaOptions';
export const VERSION = 1;
